import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ICreateAccountResult } from '@app/auth/models/create-account-result.model';
import { RegistrationFormGroupModel } from '@app/shared/models/registration-form-group.model';
import { Observable } from 'rxjs';
import { CustomerRegistrationMapperService } from './customer-registration-mapper.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerRegistrationHttpService {

  private readonly http = inject(HttpClient);
  private readonly customerRegistrationMapperService = inject(CustomerRegistrationMapperService);

  public createAccount(customerRegistrationForm: RegistrationFormGroupModel): Observable<ICreateAccountResult> {
    const registrationRequestModel = this.customerRegistrationMapperService.mapRegistrationFormToRegistrationRequestModel(customerRegistrationForm);
    return this.http.post<ICreateAccountResult>('/api/account/register', registrationRequestModel);
  };
}
